import type { FundingApplicationSchemas } from "api-types";

import { UploadDocumentType } from "../types";

export const CUSTOMER_BUSINESS_MODEL_API = "/api/:customerSlug/customer-details/api/business-model";
export const FUNDING_APPLICATION_API = "/api/:customerSlug/funding/api/application/";
export const SUBSEQUENT_FUNDING_APPLICATION_API = "/api/:customerSlug/funding/api/application/subsequent-funding/";
export const FUNDING_APPLICATION_STATE_API = "/api/:customerSlug/funding/api/applicationstate/";
export const FUNDING_APPLICATION_CONNECTORS_API = "/api/:customerSlug/funding/api/connectors/";
export const FUNDING_APPLICATION_COMPLETE_CONNECTION_API =
  "/api/:customerSlug/funding/api/connectors/complete-connection";
export const FUNDING_APPLICATION_CONNECTOR_TYPE_API = "/api/:customerSlug/funding/api/connectors/:connectorType";
export const FUNDING_APPLICATION_CONFIGURE_NEW_FUNDER_CUSTOMER_API =
  "/api/:customerSlug/funding/api/configure-new-funder-customer/";
export const FUNDING_APPLICATION_CONFIGURATION_API = "/api/:customerSlug/funding/api/application-configuration/";
export const FUNDING_APPLICATION_CONNECTIONS_PREVIEW_API =
  "/api/:customerSlug/funding/api/application-configuration/connections-preview/";
export const FUNDING_APPLICATION_CONFIGURATION_COMPLETION_STATUS_API =
  "/api/:customerSlug/funding/api/application-configuration/completion-status";
export const FUNDING_APPLICATION_IS_SUBMITTABLE_API =
  "/:customerSlug/funding/api/application-configuration/:applicationId/submittable";

export const USER_DATA_API = "/api/:customerSlug/user-data/api/data";
export const USER_DATA_VALIDATION_API = "/api/:customerSlug/user-data/api/validate";
export const BANK_CONNECT_API = "/api/:customerSlug/funding/api/bank-connect";
export const BANK_STATEMENTS_API = "/api/:customerSlug/funding/api/bank-connect/statements";
export const BANK_CONNECT_SOURCES_API = "/api/:customerSlug/funding/api/bank-connect/sources";

export const BANK_STATEMENTS_SUBMIT_API = "/api/:customerSlug/customer-bank-statement-uploads/submit";
export const BANK_STATEMENTS_CONFIRM_UPLOAD_API = "/api/:customerSlug/customer-bank-statement-uploads/confirm-upload";
export const BANK_STATEMENTS_CREATE_UPLOAD_API = "/api/:customerSlug/customer-bank-statement-uploads/create-upload-url";
export const BANK_STATEMENTS_DELETE_UPLOAD_API = "/api/:customerSlug/customer-bank-statement-uploads/delete-upload";
export const BANK_STATEMENTS_EXTRACTION_STATUS_API =
  "/api/:customerSlug/customer-bank-statement-uploads/extraction-status";

export const DOCUMENT_UPLOADS_API = "/api/:customerSlug/funding/api/application/:applicationId/document-uploads";
export const DOCUMENT_TYPE_UPLOADS_API = `${DOCUMENT_UPLOADS_API}/:documentType`;

export const VALIDATED_DOCUMENT_UPLOADS_API =
  "/api/:customerSlug/funding/api/application/:applicationId/validated-document-uploads";
export const VALIDATED_DOCUMENT_TYPE_UPLOADS_API = `${VALIDATED_DOCUMENT_UPLOADS_API}/:documentType`;

export const FUNDING_APPLICATION_REVIEW_STATUS_API = "/api/:customerSlug/funding/api/review/status";
export const FUNDING_APPLICATION_REVIEW_AIR_API = "/api/:customerSlug/funding/api/review/air";
export const AIR_BANK_STATEMENT_UPDATE_API = "/api/:customerSlug/funding/api/review/air/statements";
export const AIR_REVENUE_SOURCE_UPDATE_API = "/api/:customerSlug/funding/api/review/air/revenue-source";
export const AIR_RECONNECT_CONNECTION_UPDATE_API = "/api/:customerSlug/funding/api/review/air/reconnect-connection";

export {
  ADD_MORE_STATEMENTS_QUERY_PARAM,
  UPLOAD_STATEMENTS_SIZE_LIMIT_MB,
  UPLOAD_STATEMENTS_SUCCESS_QUERY_PARAM,
  UPLOAD_STATEMENTS_SUPPORTED_EXTENSIONS,
} from "shared-utils";

export const SUBSEQUENT_FUNDING_DATA_PULL_PROGRESS_KEY = "sf-dp-progress-:productRequestId";
export const UPLOAD_STATEMENTS_BANK_GROUP_LOCATION_STATE = "bank-group";

export const SUBSEQUENT_FUNDING_DATA_PULL_PROGRESS_WINDOW_SECONDS = 60;

export enum CONNECT_APP_ROUTE_PATHS {
  ADDITIONAL_INFORMATION_REQUEST = "additional-information-request",
  CONNECTIONS = "connections",
  ADD_CONNECTION = "add",
  MARKETING = "marketing",
  ECOMMERCE = "ecommerce",
  BANKING = "banking",
  BANK_STATEMENTS_UPLOAD = "upload-statements",
  ACCOUNTING = "accounting",
  UPLOADS = "uploads",
  UPLOADS_SUSA = "susa",
  UPLOADS_POOLBANCARIO = "poolbancario",
  BUSINESS_MODEL = "business-model",
  INELIGIBLE = "ineligible",
  IN_REVIEW = "in-review",
  UPLOADS_CASH_FLOW = "cash-flow",
  UPLOADS_PURCHASE_ORDERS = "purchase-orders",
  UPLOADS_DEBT_AGREEMENTS = "debt-agreements",
  UPLOADS_MANAGEMENT_ACCOUNTS = "management-accounts",
  ADDITIONAL_FUNDING = "additional-funding",
  LANDING = "landing",
  CUSTOMER_TASKS = "tasks",
  CONFIGURE_NEW_FUNDER_CUSTOMER = "configure-new-funder-customer",
  VERIFY = "verify",
  CONSENT = "consent",
  CREDIT_CHECK = "credit-check",
  HOME = "home",
  FINANCING = "financing",
}

export enum NAVIGATION_PATHS {
  CONNECTIONS = `/${CONNECT_APP_ROUTE_PATHS.CONNECTIONS}`,
  ADD_CONNECTION = `/${CONNECT_APP_ROUTE_PATHS.CONNECTIONS}/${CONNECT_APP_ROUTE_PATHS.ADD_CONNECTION}`,
  ECOMMERCE = `/${CONNECT_APP_ROUTE_PATHS.CONNECTIONS}/${CONNECT_APP_ROUTE_PATHS.ECOMMERCE}`,
  MARKETING = `/${CONNECT_APP_ROUTE_PATHS.CONNECTIONS}/${CONNECT_APP_ROUTE_PATHS.MARKETING}`,
  ACCOUNTING = `/${CONNECT_APP_ROUTE_PATHS.CONNECTIONS}/${CONNECT_APP_ROUTE_PATHS.ACCOUNTING}`,
  BANKING = `/${CONNECT_APP_ROUTE_PATHS.CONNECTIONS}/${CONNECT_APP_ROUTE_PATHS.BANKING}`,
  BANK_STATEMENTS_UPLOAD = `/${CONNECT_APP_ROUTE_PATHS.CONNECTIONS}/${CONNECT_APP_ROUTE_PATHS.BANKING}/${CONNECT_APP_ROUTE_PATHS.BANK_STATEMENTS_UPLOAD}`,
  SUSA = `/${CONNECT_APP_ROUTE_PATHS.UPLOADS}/${CONNECT_APP_ROUTE_PATHS.UPLOADS_SUSA}`,
  POOL_BANCARIO = `/${CONNECT_APP_ROUTE_PATHS.UPLOADS}/${CONNECT_APP_ROUTE_PATHS.UPLOADS_POOLBANCARIO}`,
  PURCHASE_ORDERS = `/${CONNECT_APP_ROUTE_PATHS.UPLOADS}/${CONNECT_APP_ROUTE_PATHS.UPLOADS_PURCHASE_ORDERS}`,
  DEBT_AGREEMENTS = `/${CONNECT_APP_ROUTE_PATHS.UPLOADS}/${CONNECT_APP_ROUTE_PATHS.UPLOADS_DEBT_AGREEMENTS}`,
  MANAGEMENT_ACCOUNTS = `/${CONNECT_APP_ROUTE_PATHS.UPLOADS}/${CONNECT_APP_ROUTE_PATHS.UPLOADS_MANAGEMENT_ACCOUNTS}`,
  CASH_FLOW = `/${CONNECT_APP_ROUTE_PATHS.UPLOADS}/${CONNECT_APP_ROUTE_PATHS.UPLOADS_CASH_FLOW}`,
  IN_REVIEW = `/${CONNECT_APP_ROUTE_PATHS.IN_REVIEW}`,
  ADDITIONAL_INFORMATION_REQUEST = `/${CONNECT_APP_ROUTE_PATHS.IN_REVIEW}/${CONNECT_APP_ROUTE_PATHS.ADDITIONAL_INFORMATION_REQUEST}`,
  HOME_ADDITIONAL_INFORMATION_REQUEST = `/${CONNECT_APP_ROUTE_PATHS.HOME}/${CONNECT_APP_ROUTE_PATHS.ADDITIONAL_INFORMATION_REQUEST}`,
  FINANCING_ADDITIONAL_INFORMATION_REQUEST = `/${CONNECT_APP_ROUTE_PATHS.FINANCING}/${CONNECT_APP_ROUTE_PATHS.ADDITIONAL_INFORMATION_REQUEST}`,
  ADDITIONAL_FUNDING_TASKS = `/${CONNECT_APP_ROUTE_PATHS.ADDITIONAL_FUNDING}/${CONNECT_APP_ROUTE_PATHS.CUSTOMER_TASKS}`,
  ADDITIONAL_FUNDING_ADDITIONAL_INFORMATION_REQUEST = `/${CONNECT_APP_ROUTE_PATHS.ADDITIONAL_FUNDING}/${CONNECT_APP_ROUTE_PATHS.CUSTOMER_TASKS}`,
  CREDIT_CHECK_CONSENT = `/${CONNECT_APP_ROUTE_PATHS.CONSENT}/${CONNECT_APP_ROUTE_PATHS.CREDIT_CHECK}`,
}

// Application stage from navigation path
export const NAVIGATION_PATH_TO_ROUTE_PATH_MAP: Record<string, string> = {
  [NAVIGATION_PATHS.CONNECTIONS]: CONNECT_APP_ROUTE_PATHS.CONNECTIONS,
  [NAVIGATION_PATHS.ECOMMERCE]: CONNECT_APP_ROUTE_PATHS.ECOMMERCE,
  [NAVIGATION_PATHS.MARKETING]: CONNECT_APP_ROUTE_PATHS.MARKETING,
  [NAVIGATION_PATHS.ACCOUNTING]: CONNECT_APP_ROUTE_PATHS.ACCOUNTING,
  [NAVIGATION_PATHS.BANKING]: CONNECT_APP_ROUTE_PATHS.BANKING,
  [NAVIGATION_PATHS.IN_REVIEW]: CONNECT_APP_ROUTE_PATHS.IN_REVIEW,
  [NAVIGATION_PATHS.ADDITIONAL_INFORMATION_REQUEST]: CONNECT_APP_ROUTE_PATHS.ADDITIONAL_INFORMATION_REQUEST,
};

export const ECOMMERCE_CONNECTOR_SLUGS_LEGACY = [
  "shopify2",
  "shopify-appstore",
  "amazonrutter",
  "woocommerce2",
  "bigcommercerutter",
  "magento2",
  "prestashop",
  "mockify",
];

export const REVENUE_CONNECTOR_SLUGS = [
  "shopify2",
  "shopify-appstore",
  "amazonrutter",
  "woocommerce2",
  "bigcommercerutter",
  "magento2",
  "prestashop",
  "mockify",
  "stripe2",
  "ga",
];

export const MARKETING_CONNECTOR_SLUGS = ["google_ads2", "facebook2", "tiktok"];

export const ACCOUNTING_CONNECTOR_SLUGS = ["xero", "netsuite", "quickbooks", "codat_accounting", "codat_file_uploads"];

export const getProviderType = (slug: string): string => {
  if (ACCOUNTING_CONNECTOR_SLUGS.includes(slug)) {
    return "accounting";
  }
  if (MARKETING_CONNECTOR_SLUGS.includes(slug)) {
    return "marketing";
  }
  if (REVENUE_CONNECTOR_SLUGS.includes(slug)) {
    return "online_sales";
  }
  return "unknown";
};

export const ORDERED_CONNECTOR_SLUGS = [
  ...REVENUE_CONNECTOR_SLUGS,
  ...ACCOUNTING_CONNECTOR_SLUGS,
  ...MARKETING_CONNECTOR_SLUGS,
];

export const ORDERED_DOCUMENT_UPLOADS = [
  UploadDocumentType.SUSA,
  UploadDocumentType.POOL_BANCARIO,
  UploadDocumentType.COMPANY_DEBT_AGREEMENT,
  UploadDocumentType.CASH_FLOW_FORECAST,
];

// IMPORTANT: If you change these thresholds please keep in sync with
// funding_application/services/external_services.py
export const ACCOUNTING_THRESHOLD_BY_CURRENCY: Record<string, number> = {
  USD: 500000,
  EUR: 500000,
  GBP: 400000,
  SEK: 5000000,
  DKK: 3600000,
  CAD: 650000,
  AUD: 750000,
};

// IMPORTANT: If you change these thresholds please keep in sync with
// funding_application/services/external_services.py
export const RSS_ACCOUNTING_THRESHOLD_BY_CURRENCY: Record<string, number> = {
  USD: 150000,
  EUR: 130000,
  GBP: 150000,
  SEK: 1400000,
  DKK: 955000,
  CAD: 210000,
  AUD: 150000,
};

export const CASHFLOW_THRESHOLD_BY_CURRENCY: Record<string, number> = {
  USD: 250000,
  EUR: 250000,
  GBP: 200000,
  SEK: 2500000,
  DKK: 1800000,
  CAD: 325000,
  AUD: 375000,
};

export type AirResponseInFlightData = {
  type: FundingApplicationSchemas.AdditionalInformationRequestType;
  airPublicIdentifier: string;
  expiry: string;
};

// RSS eligible geos
export const RSS_GEOS = ["US", "GB", "AU"];
